<div class="header">
    <div class="row">
        <div class="col-6">
            <h2>Modifica <strong>Segnalatore</strong></h2>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/segnalatori']">Segnalatori</a></li>
                <li class="active">Modifica Segnalatore</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-10 portlets" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div *ngIf="formError && referrer.IDReferrer === undefined" class="alert alert-danger" role="alert">{{ formError }}</div>
                <div *ngIf="referrer.IDReferrer !== undefined" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                    <div class="col-sm-8 offset-sm-2">
                        <div *ngIf="formError" class="alert alert-danger" role="alert">{{ formError }}</div>
                        <form #referrerForm="ngForm" role="form" class="form-horizontal form-validation">
                            <p class="section-referrer-data">Dati relativi al Segnalatore</p>

                            <div class="form-group">
                                <label for="name" class="col-sm-3 control-label">Nome</label>
                                <div class="col-sm-9 field-column">
                                    <div class="prepend-icon">
                                        <input type="text"
                                               id="name"
                                               name="name"
                                               class="form-control"
                                               [class.input-error]="nameError"
                                               placeholder="Inserisci il nome"
                                               autocomplete="off"
                                               [(ngModel)]="referrer.Name">
                                        <i class="icon-user"></i>
                                    </div>
                                    <span class="field-error" *ngIf="nameError">{{ nameError }}</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="surname" class="col-sm-3 control-label">Cognome</label>
                                <div class="col-sm-9 field-column">
                                    <div class="prepend-icon">
                                        <input type="text"
                                               id="surname"
                                               name="surname"
                                               class="form-control"
                                               [class.input-error]="surnameError"
                                               placeholder="Inserisci il cognome"
                                               autocomplete="off"
                                               [(ngModel)]="referrer.Surname">
                                        <i class="icon-user"></i>
                                    </div>
                                    <span class="field-error" *ngIf="surnameError">{{ surnameError }}</span>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="email" class="col-sm-3 control-label">Email</label>
                                <div class="col-sm-9 field-column">
                                    <div class="prepend-icon">
                                        <input type="email"
                                               id="email"
                                               name="email"
                                               class="form-control"
                                               [class.input-error]="emailError"
                                               placeholder="Inserisci indirizzo email"
                                               autocomplete="off"
                                               [(ngModel)]="referrer.Email">
                                        <i class="icon-envelope"></i>
                                    </div>
                                    <span class="field-error" *ngIf="emailError">{{ emailError }}</span>
                                </div>
                            </div>
                        </form>

                        <div class="row" style="margin-top: 30px;">
                            <div class="col-sm-9 offset-sm-3 text-right">
                                <a class="btn btn-embossed btn-default" style="margin-right: 10px;"
                                   [routerLink]="['/segnalatori']">Annulla</a>
                                <button type="button"
                                        class="btn btn-embossed btn-primary"
                                        (click)="saveAndGoToList()">Salva</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
